// import { getSession } from '@/utils';
const url = 'http://8.130.19.138:8002'
// const url = 'http://10.10.27.161:8011'
const config = {
    baseURL: url,
    timeout: 15000,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
}

export default config;



// WEBPACK FOOTER //
// ./src/config/config.js